import { render } from "./DeviceTile.vue?vue&type=template&id=396caaff"
import script from "./DeviceTile.vue?vue&type=script&lang=js"
export * from "./DeviceTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__